import { render } from "./user-profile-input.vue?vue&type=template&id=6c7ff491&scoped=true"
import script from "./user-profile-input.vue?vue&type=script&lang=js"
export * from "./user-profile-input.vue?vue&type=script&lang=js"

import "./user-profile-input.vue?vue&type=style&index=0&id=6c7ff491&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c7ff491"]])

export default __exports__